// extracted by mini-css-extract-plugin
export var formats = "CameraTeaserElement-module--formats--8090c";
export var fovButton = "CameraTeaserElement-module--fovButton--a84c6";
export var infoText = "CameraTeaserElement-module--infoText--cd945";
export var price = "CameraTeaserElement-module--price--db1f1";
export var priceLink = "CameraTeaserElement-module--priceLink--4c647";
export var teaserCardWrapper = "CameraTeaserElement-module--teaserCardWrapper--554d7";